import Vue from 'vue'
// naming convention
// raw name mean set, LOADING => mean set LOADING

// user store
let userActionTypes = {
    TOKEN: 'TOKEN',
    TOKEN_REFRESH: 'TOKEN_REFRESH',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    CURRENT_PROJECT_ID: 'CURRENT_PROJECT_ID',
    GET_PROFILE: 'GET_PROFILE',
    GET_PROJECTS: 'GET_PROJECTS',
    GET_JWT_USER: 'GET_JWT_USER',
    LOGIN_METHOD: 'LOGIN_METHOD',
    RESET_TOKEN: 'RESET_TOKEN',
    SIGN_IN: 'SIGN_IN',
    SIGN_IN_FPTID: 'SIGN_IN_FPTID',
    SIGN_IN_GOOGLE: 'SIGN_IN_GOOGLE',
    SIGN_IN_FACEBOOK: 'SIGN_IN_FACEBOOK',
    SIGN_OUT: 'SIGN_OUT',
}
let userActionTypesShortcut = { ...userActionTypes }

Object.keys(userActionTypes).forEach(item => {
    userActionTypesShortcut[item] = 'user/' + userActionTypes[item]
})

// dashboard store
let dashboardActionTypes = {
    CHART_TIME_RANGE: 'CHART_TIME_RANGE',
    CHART_INTERVAL: 'CHART_INTERVAL',
    REFRESH_INTERVAL: 'REFRESH_INTERVAL'
}

let dashboardActionTypesShortcut = { ...dashboardActionTypes }

Object.keys(dashboardActionTypes).forEach(item => {
    dashboardActionTypesShortcut[item] = 'dashboard/' + dashboardActionTypes[item]
})

// main store
const actionTypes = {
    // common for both action and mutation in main store
    LOADING: 'LOADING',
    TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
    NAVIGATION: 'NAVIGATION',
    TOUR_CONSOLE: 'TOUR_CONSOLE',
    TOKEN: 'TOKEN',
    user: { ...userActionTypesShortcut },
    dashboard: { ...dashboardActionTypesShortcut }
}

Vue.prototype.$actionTypes = actionTypes

export {
    userActionTypes,
    dashboardActionTypes,
    actionTypes
}
